export default {"src":"/_next/static/media/export-spreadsheet.6a536e65.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};